import { Table, Alert, Button, InputGroup, Form, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import axiosInstance from '../general/axiosInstance';
import React, { useEffect, useState } from 'react';
import { setIsLoading } from '../general/actions';
import { currencyFormater, LOGO_IMG_PATH } from '../general/utils';
import ProductImage from '../general/productImage';
import AlertModal from '../general/alertModal';
import Print from '../order/print';
import Log from './log';
import { STATUS_STYLE } from '../general/colors';


function StatusBadge({ status }) {
    const s = STATUS_STYLE[status?.id] || { background: '#f1f5f9', color: '#475569', border: '1px solid #cbd5e1' };
    return (
        <span className="report-status-badge" style={s}>
            {status?.id}: {status?.description}
        </span>
    );
}

function OrderSummary(props) {
    const { setIsLoading, is_provider, getOrders, orders, isApproving, roles } = props;

    const detailIcon = roles.includes('customer_approver') || roles.includes('provider_approver')
        ? <i className="fa fa-check-circle" style={{ color: '#16a34a' }} />
        : roles.includes('customer_order')
            ? <i className="fa fa-eye" />
            : <i className="fa fa-search" />;

    const [idPrint, setIdPrint]       = useState(false);
    const [showPrint, setShowPrint]   = useState(false);
    const [idOrderLog, setIdOrderLog] = useState(false);
    const [showLog, setShowLog]       = useState(false);
    const [modalDetails, setModalDetails] = useState([]);
    const [modalHeader, setModalHeader]   = useState({});
    const [showModal, setShowModal]       = useState(false);
    const [searchText, setSearchText]     = useState('');
    const [message, setMessage]           = useState('');
    const [messageType, setMessageType]   = useState('warning');
    const [alertModalShow, setAlertModalShow] = useState(false);
    const [alertModalMsg, setAlertModalMsg]   = useState('');
    const [alertImgSrc, setAlertImgSrc]       = useState('');
    const [selectedDet, setSelectedDet]       = useState(null);
    const [showProductModal, setShowProductModal] = useState(false);

    const openProductDetail = (det) => {
        setSelectedDet(det);
        setShowProductModal(true);
    };

    const approve = async (id) => {
        setIsLoading(true);
        try {
            const response = await axiosInstance.put('/orders/approve/' + id);
            if (response.status === 200) {
                setMessageType('success');
                setMessage('Pedido ' + id + ' aprobado');
                getOrders();
            } else {
                setMessageType('danger');
                setMessage('Error actualizando el pedido');
            }
        } catch (error) {
            setMessageType('danger');
            setMessage('Error actualizando el pedido');
        } finally {
            setIsLoading(false);
            setShowModal(false);
        }
    };

    useEffect(() => { if (!orders.length) getOrders(); }, []);
    useEffect(() => { setMessage(''); }, [orders]);

    const filtered = orders.filter(item =>
        !searchText.length || String(item.id) === searchText
    );

    const openDetail = (item) => {
        setModalDetails(item.order_detail);
        setModalHeader(item);
        setShowModal(true);
    };

    return (
        <>
            {/* ── Toolbar ── */}
            <div className="summary-toolbar">
                {isApproving && (
                    <span className="summary-toolbar-title">
                        Pedidos por aprobar
                    </span>
                )}
                <div className="summary-toolbar-right">
                    {orders.length > 0 && (
                        <span className="report-count" style={{ whiteSpace: 'nowrap' }}>
                            <strong>{filtered.length}</strong> de <strong>{orders.length}</strong>
                        </span>
                    )}
                    <InputGroup style={{ width: 180 }}>
                        <InputGroup.Text style={{ background: 'var(--abi-bg)', border: '1px solid var(--abi-border)', borderRight: 'none', fontSize: 12 }}>
                            <i className="fa fa-hashtag" style={{ color: 'var(--abi-muted)' }} />
                        </InputGroup.Text>
                        <Form.Control
                            placeholder="Filtrar pedido"
                            type="text"
                            value={searchText}
                            size="sm"
                            onChange={(e) => setSearchText(e.target.value)}
                            style={{ borderLeft: 'none', fontSize: 13 }}
                        />
                        {searchText && (
                            <Button variant="outline-secondary" size="sm" onClick={() => setSearchText('')}>
                                <i className="fa fa-times" />
                            </Button>
                        )}
                    </InputGroup>
                    <Button variant="outline-primary" size="sm" title="Actualizar" onClick={getOrders}>
                        <i className="fa fa-rotate-right" />
                    </Button>
                </div>
            </div>

            {message && (
                <Alert variant={messageType || 'warning'} className="py-2 mb-2" style={{ fontSize: 13 }}>
                    {message}
                </Alert>
            )}

            {/* ── Empty state ── */}
            {filtered.length === 0 && (
                <div style={{ textAlign: 'center', padding: '48px 20px 40px', color: 'var(--abi-muted)' }}>
                    <i className="fa fa-inbox" style={{ fontSize: 42, marginBottom: 14, display: 'block', opacity: 0.45 }} />
                    <div style={{ fontWeight: 700, fontSize: 15, color: 'var(--abi-text)', marginBottom: 6 }}>
                        {searchText
                            ? `No se encontró el pedido #${searchText}`
                            : isApproving
                                ? 'No hay pedidos pendientes por aprobar'
                                : 'No hay pedidos para mostrar'}
                    </div>
                    <div style={{ fontSize: 13 }}>
                        {searchText
                            ? 'Verifica el número e intenta de nuevo.'
                            : isApproving
                                ? 'Todos los pedidos están al día.'
                                : ''}
                    </div>
                </div>
            )}

            {/* ── Tabla ── */}
            {filtered.length > 0 && (
                <Table responsive className="report-table mb-0">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Pedido</th>
                            <th>Estado</th>
                            <th>{is_provider ? 'Cliente' : 'Proveedor'}</th>
                            <th className="d-none d-md-table-cell">Centro de Costos</th>
                            <th className="d-none d-lg-table-cell">Creación</th>
                            <th>Entrega</th>
                            <th className="text-end">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filtered.map(item => (
                            <tr key={'order-' + item.id} className="summary-row">
                                <td>
                                    <div style={{ display: 'flex', gap: 4 }}>
                                        <button className="report-icon-btn" title="Ver log" onClick={() => { setShowLog(true); setIdOrderLog(item.id); }}>
                                            <i className="fa fa-history" />
                                        </button>
                                        <button className="report-icon-btn" title="Ver detalle" onClick={() => openDetail(item)}>
                                            {detailIcon}
                                        </button>
                                        <button className="report-icon-btn" title="Imprimir" onClick={() => { setIdPrint(item.id); setShowPrint(true); }}>
                                            <i className="fa fa-print" />
                                        </button>
                                    </div>
                                </td>
                                <td className="report-order-id">#{item.id}</td>
                                <td><StatusBadge status={item.order_status} /></td>
                                <td>
                                    {is_provider ? (
                                        <span style={{ fontSize: 13 }}>
                                            {item.agreement.customer.ext_id} — {item.agreement.customer.name}
                                        </span>
                                    ) : (
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                            <img
                                                height="24" width="24"
                                                style={{ objectFit: 'contain', borderRadius: 4, border: '1px solid var(--abi-border)' }}
                                                src={LOGO_IMG_PATH + item.agreement.provider.id + '.png'}
                                                alt=""
                                                onError={(e) => { e.target.style.display = 'none'; }}
                                            />
                                            <span style={{ fontSize: 13 }}>
                                                {item.agreement.provider.ext_id} — {item.agreement.provider.name}
                                            </span>
                                        </div>
                                    )}
                                </td>
                                <td className="d-none d-md-table-cell" style={{ fontSize: 12, color: 'var(--abi-muted)' }}>
                                    {item.fund.department.name}
                                </td>
                                <td className="d-none d-lg-table-cell" style={{ fontSize: 12, color: 'var(--abi-muted)', whiteSpace: 'nowrap' }}>
                                    {item.created_at}
                                </td>
                                <td style={{ fontSize: 13, whiteSpace: 'nowrap' }}>
                                    <div style={{ fontWeight: 600 }}>{item.delivery_date}</div>
                                    <div style={{ fontSize: 11, color: 'var(--abi-muted)' }}>{item.delivery_time}</div>
                                </td>
                                <td className="text-end" style={{ fontWeight: 700 }}>
                                    {currencyFormater(item.total_amount)}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}

            {/* ── Modal de detalle ── */}
            <Modal show={showModal} size="lg" centered onHide={() => setShowModal(false)}>

                {/* Header */}
                <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, var(--abi-primary) 0%, #1d4ed8 100%)', borderBottom: 'none', padding: '16px 20px' }}>
                    <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', width: '100%', gap: 12 }}>
                        <div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
                                <span style={{ fontSize: 22, fontWeight: 800, color: '#fff' }}>
                                    Pedido <span style={{ opacity: 0.85 }}>#</span>{modalHeader.id}
                                </span>
                                {modalHeader.order_status && (() => {
                                    const s = STATUS_STYLE[modalHeader.order_status.id] || { background: '#f1f5f9', color: '#475569', border: '1px solid #cbd5e1' };
                                    return (
                                        <span className="report-status-badge" style={{ ...s, fontSize: 11 }}>
                                            {modalHeader.order_status.description}
                                        </span>
                                    );
                                })()}
                            </div>
                            <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.75)', display: 'flex', alignItems: 'center', gap: 6 }}>
                                <i className="fa fa-calendar-o" />
                                Creado: {modalHeader.created_at}
                            </div>
                        </div>
                        <div style={{ textAlign: 'right', flexShrink: 0 }}>
                            <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.7)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Total</div>
                            <div style={{ fontSize: 22, fontWeight: 800, color: '#fff' }}>{currencyFormater(modalHeader.total_amount)}</div>
                        </div>
                    </div>
                </Modal.Header>

                <Modal.Body style={{ padding: 0, maxHeight: '72vh', overflowY: 'auto' }}>

                    {/* ── Entrega destacada ── */}
                    <div style={{ padding: '14px 20px', background: '#f0fdf4', borderBottom: '1px solid #bbf7d0', display: 'flex', flexWrap: 'wrap', gap: 16, alignItems: 'flex-start' }}>
                        <div style={{ flex: 1, minWidth: 180 }}>
                            <div style={{ fontSize: 11, fontWeight: 700, color: '#166534', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 3 }}>
                                <i className="fa fa-truck" style={{ marginRight: 5 }} /> Fecha de entrega
                            </div>
                            <div style={{ fontSize: 16, fontWeight: 800, color: '#14532d' }}>
                                {modalHeader.delivery_date}
                                <span style={{ fontSize: 13, fontWeight: 600, color: '#16a34a', marginLeft: 8 }}>{modalHeader.delivery_time}</span>
                            </div>
                            {modalHeader.delivery_event_name && (
                                <div style={{ fontSize: 12, color: '#166534', marginTop: 2 }}>
                                    <i className="fa fa-tag" style={{ marginRight: 4 }} />{modalHeader.delivery_event_name}
                                </div>
                            )}
                        </div>
                        {modalHeader.delivery_address && (
                            <div style={{ flex: 1, minWidth: 180 }}>
                                <div style={{ fontSize: 11, fontWeight: 700, color: '#166534', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 3 }}>
                                    <i className="fa fa-map-marker" style={{ marginRight: 5 }} /> Dirección
                                </div>
                                <div style={{ fontSize: 13, fontWeight: 600, color: '#14532d' }}>{modalHeader.delivery_address}</div>
                            </div>
                        )}
                        {modalHeader.delivery_person_receiving && (
                            <div style={{ flex: 1, minWidth: 160 }}>
                                <div style={{ fontSize: 11, fontWeight: 700, color: '#166534', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 3 }}>
                                    <i className="fa fa-user-o" style={{ marginRight: 5 }} /> Recibe
                                </div>
                                <div style={{ fontSize: 13, fontWeight: 600, color: '#14532d' }}>{modalHeader.delivery_person_receiving}</div>
                                {modalHeader.delivery_phone && (
                                    <div style={{ fontSize: 12, color: '#16a34a' }}>
                                        <i className="fa fa-phone" style={{ marginRight: 4 }} />{modalHeader.delivery_phone}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    {/* ── Chips de metadata ── */}
                    <div style={{ padding: '12px 20px', display: 'flex', flexWrap: 'wrap', gap: 8, background: '#f8fafc', borderBottom: '1px solid var(--abi-border)' }}>
                        {[
                            { icon: 'fa-handshake-o', label: is_provider ? 'Cliente' : 'Proveedor', value: is_provider ? `${modalHeader.agreement?.customer?.ext_id} ${modalHeader.agreement?.customer?.name}` : `${modalHeader.agreement?.provider?.ext_id} ${modalHeader.agreement?.provider?.name}` },
                            { icon: 'fa-file-text-o', label: 'Contrato', value: `${modalHeader.agreement?.ext_id} ${modalHeader.agreement?.description}` },
                            { icon: 'fa-money',       label: 'Fondo',    value: `${modalHeader.fund?.ext_id} ${modalHeader.fund?.name}` },
                            { icon: 'fa-building-o',  label: 'Centro de costos', value: modalHeader.fund?.department?.name },
                        ].filter(c => c.value && c.value.trim() !== 'undefined undefined').map(chip => (
                            <div key={chip.label} style={{ display: 'flex', alignItems: 'center', gap: 7, background: '#fff', border: '1px solid var(--abi-border)', borderRadius: 8, padding: '5px 10px', fontSize: 12 }}>
                                <i className={`fa ${chip.icon}`} style={{ color: 'var(--abi-primary)', fontSize: 11 }} />
                                <span style={{ color: 'var(--abi-muted)', fontWeight: 600 }}>{chip.label}:</span>
                                <span style={{ fontWeight: 700, color: 'var(--abi-text)' }}>{chip.value}</span>
                            </div>
                        ))}
                        {modalHeader.notes && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: 7, background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 8, padding: '5px 10px', fontSize: 12 }}>
                                <i className="fa fa-sticky-note-o" style={{ color: '#d97706', fontSize: 11 }} />
                                <span style={{ color: '#92400e', fontWeight: 600 }}>Notas:</span>
                                <span style={{ color: '#78350f' }}>{modalHeader.notes}</span>
                            </div>
                        )}
                    </div>

                    {/* ── Tabla de productos ── */}
                    <Table responsive className="report-table mb-0" style={{ borderRadius: 0, border: 'none' }}>
                        <thead>
                            <tr>
                                <th style={{ width: 52 }}></th>
                                <th>Producto</th>
                                <th className="d-none d-sm-table-cell text-center">Cant.</th>
                                <th className="d-none d-md-table-cell">Precio u/IVA</th>
                                <th className="text-end">Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {modalDetails.map(det => {
                                const priceWithTax = Math.round(parseFloat(det.price) * ((parseFloat(det.taxes) / 100) + 1));
                                return (
                                    <tr key={'modal-' + det.id}>
                                        <td>
                                            <ProductImage url={det.product.img_url}
                                                className="pointer order-detail-thumb"
                                                alt={det.product.name}
                                                onClick={() => openProductDetail(det)}
                                                title="Ver detalle del producto"
                                            />
                                        </td>
                                        <td>
                                            <div style={{ fontWeight: 600, fontSize: 13 }}>{det.product.name}</div>
                                            <div style={{ display: 'flex', gap: 6, marginTop: 3, flexWrap: 'wrap', alignItems: 'center' }}>
                                                <span className="product-card-extid">{det.product.ext_id}</span>
                                                {det.product.product_type?.name && (
                                                    <span className="order-detail-type-badge">{det.product.product_type.name}</span>
                                                )}
                                                <span className="d-sm-none" style={{ fontSize: 12, color: 'var(--abi-muted)' }}>
                                                    × {det.quantity}
                                                </span>
                                            </div>
                                        </td>
                                        <td className="d-none d-sm-table-cell text-center">
                                            <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 32, height: 32, borderRadius: 8, background: 'var(--abi-bg)', border: '1px solid var(--abi-border)', fontWeight: 800, fontSize: 14 }}>
                                                {det.quantity}
                                            </span>
                                        </td>
                                        <td className="d-none d-md-table-cell">
                                            <div style={{ fontWeight: 600, fontSize: 13 }}>{currencyFormater(priceWithTax)}</div>
                                            <div style={{ fontSize: 11, color: 'var(--abi-muted)' }}>IVA {det.taxes}%</div>
                                        </td>
                                        <td className="text-end">
                                            <strong style={{ fontSize: 14 }}>{currencyFormater(det.total_amount)}</strong>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                        <tfoot>
                            <tr className="report-tfoot">
                                <th colSpan={4} className="text-end">Total del pedido</th>
                                <th className="text-end" style={{ fontSize: 16 }}>{currencyFormater(modalHeader.total_amount)}</th>
                            </tr>
                        </tfoot>
                    </Table>
                </Modal.Body>

                {/* Footer */}
                <Modal.Footer style={{ background: '#f8fafc', borderTop: '1px solid var(--abi-border)', padding: '12px 20px', gap: 10 }}>
                    {isApproving ? (
                        <>
                            <div style={{ marginRight: 'auto', fontSize: 13, color: 'var(--abi-muted)' }}>
                                <i className="fa fa-info-circle" style={{ marginRight: 5 }} />
                                Al aprobar se notificará al cliente y se actualizará el estado.
                            </div>
                            <Button variant="outline-secondary" size="sm" onClick={() => setShowModal(false)}>
                                Cancelar
                            </Button>
                            <Button variant="success" onClick={() => approve(modalHeader.id)} style={{ fontWeight: 700, padding: '8px 20px' }}>
                                <i className="fa fa-check" style={{ marginRight: 6 }} />
                                Aprobar pedido #{modalHeader.id}
                            </Button>
                        </>
                    ) : (
                        <Button variant="outline-secondary" size="sm" onClick={() => setShowModal(false)}>
                            Cerrar
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>

            {/* ── Modal detalle producto ── */}
            {selectedDet && (
                <Modal show={showProductModal} onHide={() => setShowProductModal(false)} size="md" centered>
                    <Modal.Header closeButton style={{ background: '#f8fafc', borderBottom: '1px solid var(--abi-border)' }}>
                        <Modal.Title style={{ fontWeight: 800, fontSize: 15 }}>
                            <span className="product-card-extid" style={{ marginRight: 8 }}>{selectedDet.product.ext_id}</span>
                            {selectedDet.product.name}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ padding: 0 }}>
                        <div className="product-detail-layout">
                            <div className="product-detail-img-wrap">
                                <ProductImage url={selectedDet.product.img_url}
                                    alt={selectedDet.product.name}
                                    className="product-detail-img"
                                />
                            </div>
                            <div className="product-detail-info">
                                {selectedDet.product.product_type?.name && (
                                    <span className="order-detail-type-badge mb-3" style={{ display: 'inline-block' }}>
                                        {selectedDet.product.product_type.name}
                                    </span>
                                )}
                                <div className="product-detail-price">
                                    {currencyFormater(Math.round(parseFloat(selectedDet.price) * ((parseFloat(selectedDet.taxes) / 100) + 1)))}
                                </div>
                                <div className="product-detail-price-breakdown">
                                    <span>Precio base: <strong>{currencyFormater(parseFloat(selectedDet.price))}</strong></span>
                                    <span>IVA ({selectedDet.taxes}%): <strong>{currencyFormater(Math.round(parseFloat(selectedDet.price) * parseFloat(selectedDet.taxes) / 100))}</strong></span>
                                </div>
                                {selectedDet.product.description && (
                                    <div className="product-detail-description">{selectedDet.product.description}</div>
                                )}
                                <div className="product-detail-meta">
                                    <div className="product-detail-meta-row">
                                        <span>Cantidad en pedido</span>
                                        <strong>{selectedDet.quantity}</strong>
                                    </div>
                                    <div className="product-detail-meta-row">
                                        <span>Total línea</span>
                                        <strong style={{ color: 'var(--abi-primary)' }}>{currencyFormater(selectedDet.total_amount)}</strong>
                                    </div>
                                    <div className="product-detail-meta-row">
                                        <span>Código</span>
                                        <strong>{selectedDet.product.ext_id}</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer style={{ background: '#f8fafc', borderTop: '1px solid var(--abi-border)' }}>
                        <Button variant="outline-secondary" size="sm" onClick={() => setShowProductModal(false)}>
                            Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}

            <Print show={showPrint} setShow={setShowPrint} idPrint={idPrint} setIdPrint={setIdPrint} />
            <Log show={showLog} setShow={setShowLog} orderId={idOrderLog} setOrderId={setIdOrderLog} />
            <AlertModal show={alertModalShow} setShow={setAlertModalShow} msg={alertModalMsg} imgSrc={alertImgSrc} />
        </>
    );
}

function mapStateToProps(state) {
    return {
        isLoading: state.isLoading,
        is_provider: state.is_provider,
        roles: state.roles || [],
    };
}

const mapDispatchToProps = { setIsLoading };

export default connect(mapStateToProps, mapDispatchToProps)(OrderSummary);
